export default "__VITE_ASSET__BmigDoJa__"